import axios, { AxiosResponse } from 'axios';
import { memoize } from 'lodash';

const memoizedGET = memoize(axios.get);
export const fetchLanguage = (path: string, cacheResult: boolean = true): Promise<AxiosResponse> =>
    cacheResult ? memoizedGET(path) : axios.get(path);

export const resolveBasePathname = (configPath: string): string => {
    const lastIndexOfConfigPath = window.location.pathname.lastIndexOf(configPath);

    if (configPath === '/' || !(lastIndexOfConfigPath + 1)) {
        return '';
    } else {
        // find index of the end of last entry of configPath
        const substringIndex = lastIndexOfConfigPath + configPath.length;
        // get first part of url, for example: if configPath = 'dist', window.location.pathname = '/dist/en-GB' result will be '/dist'
        return window.location.pathname.substring(0, substringIndex);
    }
};
